import "core-js/modules/es6.object.freeze";

var _a, _b;

import { StrokeWidth } from './../types/shape';
export var strokeWidths = Object.freeze({
  "default": '2px',
  thick: '3px',
  svg: (_a = {}, _a[StrokeWidth.Normal] = '1.2px', _a[StrokeWidth.Thick] = '3px', _a)
});
export var strokeWidthsRefresh = Object.freeze({
  "default": '1px',
  thick: '2px',
  svg: (_b = {}, _b[StrokeWidth.Normal] = '1.2px', _b[StrokeWidth.Thick] = '3px', _b)
});